<div class="mat-column-estados">
    @if (documento.tipoAsignado === 0) {
    <mat-icon matTooltip="Documento asignado" class="material-symbols-outlined">folder_shared</mat-icon>
    }
    @if (documento.tipoAsignado === 1) {
    <mat-icon matTooltip="Documento reasignado" class="material-symbols-outlined">supervisor_account</mat-icon>
    }
    @if (documento.tipoAsignado === 2) {
    <mat-icon matTooltip="Documento reasignado expirado" class="material-symbols-outlined">warning</mat-icon>
    }
    @if (documento.firmado === 1) {
    <mat-icon matTooltip="Documento firmado" class="material-symbols-outlined">vpn_key</mat-icon>
    }
    @if(documento.categoria === 3){
    <mat-icon style="color: #DC4827;" matTooltip="Urgente" class="material-symbols-outlined">priority_high</mat-icon>
    }
    @if(documento.externo === 1){
    <mat-icon style="color: #DC4827;" matTooltip="Documento ciudadano" class="material-symbols-outlined">contact_page</mat-icon>
    }
    @if(documento.impresa === 1){
    <mat-icon matTooltip="Hoja gu&iacute;a impresa" class="material-symbols-outlined">print</mat-icon>
    }
    @if(documento.tipoAtencion === 1){
    <mat-icon matTooltip="Con copia (CC)" class="material-symbols-outlined">copyright</mat-icon>
    }
</div>